/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  account: "Account",
  accountBalance: "Account balance",
  accountDetails: "Account details",
  accountHolderName: "Account holder name",
  accountId: "Account ID",
  accountIdentification: "Account identification",
  accountLifecycleNotifications: "Account lifecycle notifications",
  accountLifecycleNotificationsSettingsHaveBeenCreated:
    "Account lifecycle notifications settings have been created",
  accountLifecycleNotificationsSettingsHaveBeenUpdated:
    "Account lifecycle notifications settings have been updated",
  accountNotFound: "Account not found",
  accountNumber: "Account number",
  accountOrderingNotifications: "Account ordering notifications",
  accountOrderingNotificationsSettingsHaveBeenCreated:
    "Account ordering notifications settings have been created",
  accountOrderingNotificationsSettingsHaveBeenUpdated:
    "Account ordering notifications settings have been updated",
  accountOwner: "Account owner",
  accounts: "Accounts",
  accountsHaveBeenSettled: "Accounts have been settled",
  accountType: "Account type",
  active: "Active",
  address: "Address",
  alias: "Alias",
  aliasAccountNumber: "Alias account number",
  aliasIban: "Alias IBAN",
  aliasSortCode: "Alias sort code",
  aliasSwiftCodeBic: "Alias swift code (BIC)",
  amount: "Amount",
  approved: "Approved",
  areYouSureYouWantToDeactivateThisVirtualIban:
    "Are you sure you want to deactivate this virtual IBAN?",
  areYouSureYouWantToDisableNotifications:
    "Are you sure you want to disable notifications?",
  areYouSureYouWantToSettleAllAccounts:
    "Are you sure you want to settle all accounts?",
  areYouSureYouWantToSettleThisAccount:
    "Are you sure you want to settle this account?",
  availableFunds: "Available funds",
  backToAllAccounts: "Back to all accounts",
  balanceAfter: "Balance after",
  balanceCurrency: "Balance ({{currency}})",
  bankAccount: "Bank account",
  bankCode: "Bank code",
  beneficiaries: "Beneficiaries",
  beneficiary: "Beneficiary",
  bounceBack: "Bounce back",
  bsb: "BSB",
  business: "Business",
  closedLoopPayout: "Closed loop payout",
  completed: "Completed",
  configuration: "Configuration",
  configureAWebhookToReceiveRealTimeUpdates:
    "Configure a webhook to receive real-time updates on KYC onboarding progress.",
  configureAWebhookToReceiveRealTimeUpdatesOnAccountLifecycleEvents:
    "Configure a webhook to receive real-time updates on account suspension, reactivation, and closure events.",
  configureAWebhookToReceiveRealTimeUpdatesOnAccountOrderingEvents:
    "Configure a webhook to receive real-time updates on named accounts provisioning and alias creation progress.",
  connected: "Connected",
  connectMatching: "Connect Matching",
  country: "Country",
  created: "Created",
  createdAt: "Created at",
  createdBy: "Created by",
  createdByName: "Created by {{name}}",
  createdViaApi: "Created via API",
  credit: "Credit",
  currency: "Currency",
  customer: "Customer",
  customerId: "Customer ID",
  dateWhenTheTransactionWasCreated: "Date when the transaction was created",
  dateWhenTheTransactionWasProcessed: "Date when the transaction was processed",
  deactivate: "Deactivate",
  deactivated: "Deactivated",
  deactivateVirtualIban: "Deactivate virtual IBAN",
  disableNotification: "Disable notification",
  editSettlementSchedule: "Edit settlement schedule",
  email: "Email",
  failed: "Failed",
  gatewayPayment: "Gateway payment",
  givenAccountCouldNotBeFound: "Given account could not be found",
  history: "History",
  iban: "IBAN",
  ignored: "Ignored",
  inactive: "Inactive",
  incoming: "Incoming",
  individual: "Individual",
  inPayout: "In payout",
  inReturn: "In return",
  internal: "Internal",
  internalFx: "FX payout",
  internalReference: "Interactive reference",
  local: "Local",
  merchantBeneficiaries: "Merchant beneficiaries",
  mixedSchedule: "Mixed schedule",
  name: "Name",
  namedAccount: "Named account",
  namedAccounts: "Named accounts",
  namedAccountsBeneficiaries: "Named accounts beneficiaries",
  namedAccountsNotifications: "Named accounts notifications",
  namedAccountsNotificationsSettingsHaveBeenCreated:
    "Named accounts onboarding notifications settings have been created",
  namedAccountsNotificationsSettingsHaveBeenUpdated:
    "Named accounts onboarding notifications settings have been updated",
  namedAccountsOnboardingNotifications:
    "Named accounts onboarding notifications",
  noAccounts: "No accounts",
  noAccountsToSettle: "No accounts to settle",
  noAmountToSettle: "No amount to settle",
  noBeneficiaries: "No beneficiaries",
  noPayments: "No payments",
  noSchedule: "No schedule",
  notifications: "Notifications",
  noTransactions: "No transactions",
  noVirtualAccounts: "No virtual accounts",
  noVirtualIBANs: "No virtual IBANs",
  openLoopPayout: "Open loop payout",
  operation: "Operation",
  outgoing: "Outgoing",
  own: "Own",
  owner: "Owner",
  pausedDailySchedule: "Paused — daily schedule",
  pausedMixedSchedule: "Paused — mixed schedule",
  pausedMonthlySchedule: "Paused — monthly schedule",
  pausedWeeklySchedule: "Paused — weekly schedule",
  payment: "Payment",
  paymentRail: "Payment rail",
  paymentReference: "Payment reference",
  payments: "Payments",
  paymentScheme: "Payment scheme",
  paymentsNotifications: "Payments notifications",
  paymentsNotificationsSettingsHaveBeenCreated:
    "Payments notifications settings have been created",
  paymentsNotificationsSettingsHaveBeenUpdated:
    "{ayments notifications settings have been updated",
  payout: "Payout",
  pending: "Pending",
  pisPayment: "PIS payment",
  pleaseProvideNotificationURL: "Please provide notification URL",
  pleaseProvideValidNotificationURL: "Please provide valid notification URL",
  processing: "Processing",
  recalled: "Recalled",
  received: "Received",
  reference: "Reference",
  refreshAllAccounts: "Refresh all accounts",
  refund: "Refund",
  rejected: "Rejected",
  retry: "Retry",
  return: "Return",
  returned: "Returned",
  returnedManually: "Returned manually",
  reversal: "Reversal",
  reversed: "Reversed",
  selectCustomer: "Select customer",
  send: "Send",
  sender: "Sender",
  sepaInstant: "SEPA Instant",
  settleAccount: "Settle account",
  settleAllAccounts: "Settle all accounts",
  settlement: "Settlement",
  settlementAmountNotProvided: "Settlement amount not provided",
  settlementBalance: "Settlement balance",
  settlementOfAllAccounts: "Settlement of all accounts",
  settlementOfThisAccount: "Settlement of this account",
  settlementSchedule: "Settlement schedule",
  settlementSchedulerLoadFailed: "Load failed",
  settlesDaily: "Settles daily",
  settlesMonthly: "Settles monthly",
  settlesWeekly: "Settles weekly",
  setUpSettlementSchedule: "Set up settlement schedule",
  sortCode: "Sort code",
  state: "State",
  status: "Status",
  step: "Step",
  subtype: "Subtype",
  swiftCodeBic: "Swift code (BIC)",
  testNotificationHasBeenSent:
    "Test notification has been sent to {{notificationUrl}}",
  theAmountOfMoneyThatCanBeSettled: "The amount of money that can be settled",
  thisConfigurationAllowsYouToReceiveNotifications:
    "This configuration allows you to receive notifications for all types of payments processed on Volt Accounts, including incoming and outgoing payments.",
  topUp: "Top-up",
  toViewAccountsSelectCustomer:
    "To view accounts, please select a customer in the select customer menu in the upper left corner.",
  transactionAmount: "Transaction amount",
  transactionDate: "Transaction date",
  transactionDetails: "Transaction details",
  transactions: "Transactions",
  type: "Type",
  typeOfTransaction: "Type of transaction",
  uniqueReference: "Unique reference",
  unknownType: "Unknown Type",
  valueDate: "Value date",
  vIBANused: "vIBAN used",
  viewDetails: "View details",
  virtualAccount: "Virtual account",
  virtualAccounts: "Virtual accounts",
  virtualIBANHasBeenDeactivatedSuccessfully:
    "Virtual IBAN has been deactivated successfully",
  virtualIBANs: "Virtual IBANs",
  volt: "Volt",
  voltAccounts: "Volt accounts",
  voltId: "Volt ID",
  voltPayoutId: "Volt payout ID",
  voltRefundId: "Volt refund ID",
  voltSettlementId: "Volt settlement ID",
  voltVirtualIBANIdentifierUsedForReconciliation:
    "Volt Virtual IBAN identifier used for reconciliation of credits",
  waiting: "Waiting",
  weHaveSettledYourAccount: "We have settled your account",
  withdrawal: "Withdrawal",
  youDontHaveAnyAccountsYet: "You don't have any accounts yet.",
  youDontHaveAnyBeneficiariesYet: "You don't have any beneficiaries yet.",
  youDontHaveAnyPaymentsThatMatchTheCriteria:
    "You don't have any payments that match the criteria.",
  youDontHaveAnyPaymentsYet: "You don't have any payments yet.",
  youDontHaveAnyTransactionsYet: "You don't have any transactions yet.",
  youDontHaveAnyVIBANsYet: "You don't have any virtual IBANs yet.",
  youDontHaveAnyVirtualAccountsYet: "You don't have any virtual accounts yet.",
};
